import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useTranslation } from "@/hooks/useTranslation";

export interface BabyNamesSectionProps {
  babyCount: 1 | 2 | null;
  babyName: string;
  babyName2: string;
  onBabyNameChange: (value: string) => void;
  onBabyName2Change: (value: string) => void;
}

export function BabyNamesSection({
  babyCount,
  babyName,
  babyName2,
  onBabyNameChange,
  onBabyName2Change,
}: BabyNamesSectionProps) {
  const { t } = useTranslation();

  if (babyCount !== 1 && babyCount !== 2) {
    return null;
  }

  return (
    <div className="space-y-4">
      <Label>{t(babyCount === 2 ? "events.form.childrenHeading" : "events.form.childHeading")}</Label>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="baby-name">{t("events.form.babyName")}</Label>
          <Input
            id="baby-name"
            value={babyName}
            onChange={(e) => onBabyNameChange(e.target.value)}
            placeholder={t("events.form.babyName")}
            className="mt-1"
          />
        </div>
        {babyCount === 2 && (
          <div>
            <Label htmlFor="baby-name-2">{t("events.form.babyName2")}</Label>
            <Input
              id="baby-name-2"
              value={babyName2}
              onChange={(e) => onBabyName2Change(e.target.value)}
              placeholder={t("events.form.babyName2")}
              className="mt-1"
            />
          </div>
        )}
      </div>
    </div>
  );
}
